module.exports = __webpack_public_path__ + "img/auth_banner_xx.ac5e34c9.jpg";